import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { MessageService } from 'src/app/components/shared/message/message.service';
import { AuthService } from '../auth/auth.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private _messageService: MessageService,
    private _authService: AuthService,
    private _router: Router
  ) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        window.scroll(0, 0);

        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
          //Erro no cliente
          errorMessage = `Error: ${error.error.message}`;
        } else {
          if (request.url.indexOf(environment.URL_API) !== -1) {
            //Erro no servidor
            if (error.status === 400) {
              return throwError(error);
            } else if (error.status === 401) {
              //REVER (implementar refreshToken)
              this._authService.logout();
              errorMessage =
                'Sua sessão expirou, por favor faça login novamente.';

              this._messageService.error(errorMessage);
              this._router.navigate(['admin/identificacao']);
            } else {
              errorMessage = `Error Status: ${error.status}\nMessage: ${error.message}`;
              this._messageService.error();
            }
          }
        }
        console.error(errorMessage);
        return throwError(errorMessage);
      })
    ) as Observable<HttpEvent<any>>;
  }
}
